<template>
  <div class="content-empty mb-4" :class="[(noBorder) ? 'noBorder' : '']" >
    <div class="text-center">
      <img
        class="content-empty__image"
        src="../../../assets/img/empty-feed.svg"
        alt="Empty Campaign List"
      />
      <h6 class="content-empty__title mt-2" v-if="canCreateCampaign">Create a new campaign now</h6>
      <h6 class="content-empty__title mt-2" v-if="!canCreateCampaign">{{ alternativeText }}</h6>
      <button class="btn btn-primary mx-auto mt-4" v-if="canCreateCampaign" @click="spawnStateChangeInProfilePage(PROFILE_STATES[5])">
        <ion-icon name="ios-add-circle"></ion-icon>New Campaign
      </button>
    </div>
  </div>
</template>

<script>
    export default {
        name: "EmptyCampaign",
        props: ["emptyCampaignFor", "altText", "noBorder", "PROFILE_STATES", "user", "loggedInUser", "userCircles"],
        computed: {
          alternativeText: function () {
            let text = "";
            this.$props.altText ? text = this.$props.altText : text = "No campaigns found";
            return text;
          },
          canCreateCampaign: function() {
            return this.$props.emptyCampaignFor === 'profile' && this.$props.user._id === this.$props.loggedInUser._id && this.$props.userCircles.length;
          }
        },
        methods: {
          spawnStateChangeInProfilePage(emittedState) {
            this.$root.$emit("stateChangeFromCampaignList", emittedState);
          }
        }
    }
</script>

<style lang="scss" scoped>
  .noBorder {
    border: none !important;
  }
</style>